import { render, staticRenderFns } from "./floatAd.vue?vue&type=template&id=64fe4aee&"
import script from "./floatAd.vue?vue&type=script&lang=js&"
export * from "./floatAd.vue?vue&type=script&lang=js&"
import style0 from "./floatAd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports